<template>
	<div style="position: relative;">
		<app-subheader></app-subheader>
		<div class="container">
			<section class="espectaculos-home">
				<div class="espectaculos-top">
					<h2>Próximos espectáculos</h2>
					<router-link :to="{ name: 'espectaculos' }">Ver todos los espectáculos</router-link>
				</div>
				<div class="espectaculos-row" v-if="cargandoEspectaculos">
					<vcl-facebook style="margin-right: 20px;"></vcl-facebook>
					<vcl-facebook style="margin-right: 10px;margin-left: 10px;"></vcl-facebook>
					<vcl-facebook style="margin-left: 20px;"></vcl-facebook>
				</div>
				<div class="espectaculos-row" v-else-if="hayEspectaculos">
					<a @click="irAEspectaculo(espectaculo.EspectaculoId, index)" class="espectaculo" :class="{ 'espectaculo-alternativo': !espectaculo.EspectaculoTipoRequiereInstitucion, 'espectaculo-agotado': espectaculo.EspectaculoAgotado }" v-for="(espectaculo, index) in espectaculos.slice(0, 3)" :key="espectaculo.id">
						<div class="espectaculo-agotado-overlay" v-if="espectaculo.EspectaculoAgotado">
							<span>Localidades agotadas</span>
						</div>
						<div class="espectaculo-tipo" :style="{ 'background-color' : '#' + espectaculo.EspectaculoTipoColor }">
							{{ espectaculo.EspectaculoTipoNombre }}
						</div>
						<div class="espectaculo-top" v-if="!espectaculo.EspectaculoTipoRequiereInstitucion && espectaculo.EspectaculoMiniaturaURL">
							<img class="espectaculo-miniatura" :src="espectaculo.EspectaculoMiniaturaURL" :alt="espectaculo.EspectaculoNombre">
						</div>
						<div class="espectaculo-top" v-if="espectaculo.EspectaculoTipoRequiereInstitucion">
							<div class="equipo equipo-local">
								<img v-if="espectaculo.InstitucionLocalEscudoURL !== ''" :src="espectaculo.InstitucionLocalEscudoURL" :alt="espectaculo.InstitucionLocalNombre">
								<span>{{ espectaculo.InstitucionLocalNombre }}</span>
							</div>
							<span class="vs">vs.</span>
							<div class="equipo equipo-visitante">
								<img v-if="espectaculo.InstitucionVisitanteEscudoURL !== ''" :src="espectaculo.InstitucionVisitanteEscudoURL" :alt="espectaculo.InstitucionVisitanteNombre">
								<span>{{ espectaculo.InstitucionVisitanteNombre }}</span>
							</div>
						</div>
						<div class="titulo-alternativo" v-else>
							{{ espectaculo.EspectaculoNombre }}
						</div>
						<div class="espectaculo-info" v-if="espectaculo.EspectaculoFrontMostrarFecha || espectaculo.EspectaculoFrontMostrarEscenario">
							<div class="fecha-lugar">
								<span class="fecha" v-if="espectaculo.EspectaculoFrontMostrarFecha">{{ espectaculo.EspectaculoFechaEscrita }}</span>
								<span class="lugar" v-if="espectaculo.EspectaculoFrontMostrarEscenario">
									<img v-if="espectaculo.EscenarioLogoURL !== ''" :src="espectaculo.EscenarioLogoURL" :alt="espectaculo.EscenarioNombre">
									{{ espectaculo.EscenarioNombre }}
								</span>
							</div>
							<div class="fecha-hora" v-if="espectaculo.EspectaculoFrontMostrarFecha">{{ espectaculo.EspectaculoHora }}</div>
						</div>
						<div class="espectaculo-competencia" v-if="espectaculo.EspectaculoFrontMostrarCompetencia">
							<img v-if="espectaculo.CompetenciaImagenURL !== ''" :src="espectaculo.CompetenciaImagenURL" :alt="espectaculo.CompetenciaNombre">
							<div class="espectaculo-competencia-info">
								<span class="nombre-competencia">{{ espectaculo.CompetenciaNombre }}</span>
								<span class="instancia-competencia">{{ espectaculo.CompetenciaInstanciaNombre }}</span>
							</div>
						</div>
						<div class="espectaculo-bottom">
							<div class="espectaculo-bottom-right"></div>
						</div>
					</a>
				</div>
				<div class="espectaculos-row" v-else>
					<span class="no-espectaculos">No hay espectáculos disponibles<frown-icon></frown-icon></span>
				</div>
			</section>

			<section class="espectaculos-home">
				<div class="espectaculos-top">
					<h2>Paseo del Parque</h2>
				</div>
				<div class="espectaculos-row">
					<router-link :to="{ name: 'paseos-gpc' }" class="espectaculo espectaculo-paseo">
						<div class="espectaculo-tipo" :style="{ 'background-color' : '#0168fa' }">
							Paseo del parque
						</div>
						<div class="paseo-top">
							<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/paseo-gpc.svg" alt="Paseo del GPC">
						</div>
						<div class="paseo-button">
							Ver agenda
						</div>
						<div class="paseo-footer">
							<img src="https://cnf-s3-bucket.s3.us-east-1.amazonaws.com/paseo-gpc-footer.svg" alt="Paseo del GPC">
						</div>
						<div class="espectaculo-bottom">
							<div class="espectaculo-bottom-right"></div>
						</div>
					</router-link>
				</div>
			</section>

			<!-- <section class="espectaculos-home">
				<div class="espectaculos-top">
					<h2>Abonos</h2>
					<router-link :to="{ name: 'abonos' }">Ver todos los abonos</router-link>
				</div>
				<div class="espectaculos-row" v-if="cargandoEspectaculosAbonos">
					<vcl-facebook style="margin-right: 20px;"></vcl-facebook>
					<vcl-facebook style="margin-right: 10px;margin-left: 10px;"></vcl-facebook>
					<vcl-facebook style="margin-left: 20px;"></vcl-facebook>
				</div>
				<div class="espectaculos-row" v-else-if="hayEspectaculosAbonos">
					<a @click="irAEspectaculo(espectaculo.EspectaculoId, index)" class="espectaculo espectaculo-abono" :class="{ 'espectaculo-alternativo': !espectaculo.EspectaculoTipoRequiereInstitucion, 'espectaculo-agotado': espectaculo.EspectaculoAgotado }" v-for="(espectaculo, index) in espectaculosAbonos" :key="espectaculo.id" v-if="index <= 2">
						<div class="espectaculo-agotado-overlay" v-if="espectaculo.EspectaculoAgotado">
							<span>Localidades agotadas</span>
						</div>
						<div class="espectaculo-tipo" :style="{ 'background-color' : '#' + espectaculo.EspectaculoTipoColor }">
							{{ espectaculo.EspectaculoTipoNombre }}
						</div>
						<div class="espectaculo-top" v-if="!espectaculo.EspectaculoTipoRequiereInstitucion && espectaculo.EspectaculoMiniaturaURL">
							<img class="espectaculo-miniatura" :src="espectaculo.EspectaculoMiniaturaURL" :alt="espectaculo.EspectaculoNombre">
						</div>
						<div class="titulo-alternativo" v-else>
							{{ espectaculo.EspectaculoNombre }}
						</div>
						<div class="espectaculo-bottom">
							<div class="espectaculo-bottom-right"></div>
						</div>
					</a>
				</div>
				<div class="espectaculos-row" v-else>
					<span class="no-espectaculos">No hay abonos a la venta<frown-icon></frown-icon></span>
				</div>
			</section> -->
		</div>
	</div>
</template>

<script>
	import axios from 'axios'
	import SubHeader from './../components/Shared/SubHeader.vue';
	// import { FrownIcon, CalendarIcon } from 'vue-feather-icons'
	import { FrownIcon } from 'vue-feather-icons'
	import { VclFacebook } from 'vue-content-loading';

	export default {
		data(){
			return{
				hayEspectaculos: false,
				hayEspectaculosAbonos: false,
				espectaculos: [],
				cargandoEspectaculos: false,
				espectaculosAbonos: [],
				cargandoEspectaculosAbonos: false
			}
		},
		components: {
			'app-subheader': SubHeader,
			FrownIcon,
			VclFacebook,
			// CalendarIcon
		},
		async mounted(){
			if(this.$store.getters.loggedIn === false){
				window.location.href = process.env.VUE_APP_URL_NACIONALUY;
			}

			this.$store.dispatch('cargando', true);
			// localStorage.removeItem('isPagando');

			this.cargandoEspectaculos = true;
			await this.cargoEspectaculos();

			// this.cargandoEspectaculosPaseos = true;
			// await this.cargoEspectaculosPaseos();
			// this.cargandoEspectaculosAbonos = true;
			// await this.cargoEspectaculosAbonos();
			this.$store.dispatch('cargando', false);
		},
		methods: {
			irAEspectaculo(id, index){
				if(this.espectaculos[index].EspectaculoAgotado === true){
					this.$store.dispatch('mostrarError', '¡Localidades agotadas!')
				} else {
					this.$router.push({ name: 'espectaculo', params: { espectaculoId: parseInt(id) } })
				}
			},
			async cargoEspectaculos(){
				// Obtengo los espectáculos del inicio
				try {
					let response = await axios.post('/WSEspectaculosInicio', {});
	
					if(response.data.ErrorCod === 0){
						if(response.data.SDTEspectaculos.length > 0){
							this.hayEspectaculos = true;
							this.espectaculos = response.data.SDTEspectaculos;
						} else {
							this.hayEspectaculos = false;
							this.espectaculos = [];
						}
					} else {
						this.hayEspectaculos = false;
						this.espectaculos = [];
					}

					this.cargandoEspectaculos =  false
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			// async cargoEspectaculosAbonos(){
			// 	// Obtengo los abonos del inicio
			// 	try {
			// 		let response = await axios.post('/WSEspectaculosAbonosInicio', {});
	
			// 		if(response.data.ErrorCod === 0){
			// 			if(response.data.SDTEspectaculos.length > 0){
			// 				this.hayEspectaculosAbonos = true;
			// 				this.espectaculosAbonos = response.data.SDTEspectaculos;
			// 			} else {
			// 				this.hayEspectaculosAbonos = false;
			// 				this.espectaculosAbonos = [];
			// 			}
			// 		} else {
			// 			this.hayEspectaculosAbonos = false;
			// 			this.espectaculosAbonos = [];
			// 		}

			// 		this.cargandoEspectaculosAbonos =  false
			// 	} catch (error) {
			// 		this.$router.push({ name: 'error' });
			// 	}
			// },
		}
	}
</script>

<style scoped lang="scss">
	.espectaculos-home{
		@include flex(column, flex-start, flex-start);
		margin-top: 64px;

		.espectaculos-top{
			width: 100%;
			@include flex(row, space-between, center);
			margin: 0;
			margin-bottom: 10px;

			h2{
				margin-top: 0px;
				margin-bottom: 24px;
				color: var(--color-red);
				font-size: 48px;
				line-height: 46px;
				font-family: var(--font-family-kapra-bold);
				text-transform: uppercase;
			}

			a{
				text-transform: uppercase;
				font-family: var(--font-family-poppins);
				font-weight: var(--font-weight-bold);
				position: relative;
				cursor: pointer;
				-webkit-text-decoration: none;
				text-decoration: none;
				background-color: transparent;
				color: var(--color-dark);
				font-size: 16px;
				line-height: 25px;
				-webkit-letter-spacing: 0;
				-moz-letter-spacing: 0;
				-ms-letter-spacing: 0;
				letter-spacing: 0;
				@include flex(row, center, center);

				&:after{
					content: "";
					width: 30%;
					height: 4px;
					background-color: var(--color-red);
					position: absolute;
					top: 100%;
					right: 0;
					-webkit-transition: width .3s ease;
					transition: width .3s ease;
				}

				&:hover{
					&:after{
						width: 100%;
					}
				}
			}
		}

		.espectaculos-row{
			// @include flex(row, space-between, center);
			// flex-wrap: wrap;
			width: 100%;
			margin: 0;
			margin-bottom: 30px;
			margin-top: 10px;

			display: grid;
			grid-template-columns: repeat(3, 1fr);
			// grid-auto-rows: 1fr;
			grid-column-gap: 30px;
			grid-row-gap: 30px;

			& > svg{
				width: 390px;
			}

			.no-espectaculos{
				width: 100%;
				margin: 0;
				background-color: #f3f3f9;
				border-radius: 4px;
				line-height: 1em;
				padding: 15px;
				font-weight: 700;
				font-size: 13px;
				@include flex(row, center, center);

				svg{
					line-height: 1em;
					width: 16px;
					height: 16px;
					margin-left: 5px;
				}
			}
		}

		.espectaculo{
			// width: calc(33% - 15px);
			width: 100%;
			min-height: 286px;
			border-radius: 0px;
			padding: 25px;
			padding-bottom: 35px;
			position: relative;
			cursor: pointer;
			box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.07);
			transition: all .2s;
			text-decoration: none;
			background-color: var(--color-white);

			&.espectaculo-agotado{
				.espectaculo-tipo{
					background-color: var(--color-grey-medium) !important;
					color: var(--color-grey);
				}

				.espectaculo-bottom{
					background-color: var(--color-grey-light);

					.espectaculo-bottom-right{
						background-color: var(--color-grey-lighter);
					}
				}

				.espectaculo-agotado-overlay{
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 100%;
					@include flex(column, center, center);
					background-color: rgba(255, 255, 255, 0.8);

					span{
						color: var(--color-white);
						font-weight: var(--font-weight-bold);
						font-size: 17px;
						font-family: var(--font-family-poppins);
						padding: 8px 10px;
						text-transform: uppercase;
						background-color: var(--color-red);
						transform: rotate(-20deg);
						-webkit-transform: rotate(-20deg);
					}
				}
			}

			.espectaculo-tipo{
				position: absolute;
				left: 50%;
				transform: translateX(-50%);
				top: -9px;
				border-radius: 44px;
				padding: 3px 12px;
				background-color: var(--color-red);
				color: var(--color-white);
				font-size: 10px;
				line-height: 1.3em;
				text-transform: uppercase;
				font-family: var(--font-family-poppins);
			}

			.espectaculo-top{
				display: flex;
				flex-direction: row;
				justify-content: space-around;
				align-items: flex-start;
				margin: 0;
				padding: 0;
				padding-bottom: 25px;

				.equipo{
					display: flex;
					flex-direction: column;
					justify-content: flex-start;
					align-items: center;
					width: calc(50% - 15px);

					img{
						height: 64px;
						width: auto;
					}

					span{
						font-family: var(--font-family-poppins);
						font-weight: var(--font-weight-bold);
						font-size: 15px;
						color: var(--color-blue-dark);
						text-align: center;
						line-height: 1.3em;
						margin-top: 10px;
						min-height: 32px;
						-webkit-letter-spacing: -0.4px;
						-moz-letter-spacing: -0.4px;
						-ms-letter-spacing: -0.4px;
						letter-spacing: -0.4px;
						text-transform: uppercase;
						@include flex(column, center, center);
					}
				}

				span.vs{
					font-family: var(--font-family-fira);
					color: var(--color-red);
					font-weight: var(--font-weight-bold);
					text-align: center;
					line-height: 1.2em;
					font-size: 20px;
					max-width: 30px;
					@include flex(column, center, center);
					height: 64px;
				}

				.espectaculo-miniatura{
					height: 80px;
					margin-bottom: -35px;
				}
			}

			&:hover{
				box-shadow: 0 2px 48px 0 rgba(0, 0, 0, 0.12);
			}

			.espectaculo-info{
				width: 100%;
				display: flex;
				flex-direction: row;
				justify-content: center;
				align-items: center;
				margin-bottom: 20px;

				.fecha-calendar{
					width: 40px;
					height: 40px;
					overflow: hidden;
					padding: 0;
					margin: 0;
					margin-right: 14px;
					border: 1px solid #054085;
					background-color: #fff;
					border-radius: 4px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;

					.fecha-calendar-mes{
						color: #054085;
						text-transform: uppercase;
						font-size: 11px;
						font-weight: 800;
					}

					.fecha-calendar-dia{
						color: #054085;
						text-transform: uppercase;
						font-size: 18px;
						font-weight: 600;
					}
				}

				.fecha-lugar{
					@include flex(column, center, flex-start);

					.fecha{
						font-weight: var(--font-weight-regular);
						font-size: 15px;
						color: var(--color-blue-dark);
						font-family: var(--font-family-fira);
						line-height: 1.3em;
					}

					.lugar{
						font-weight: var(--font-weight-bold);
						font-size: 14px;
						color: var(--color-blue-dark);
						font-family: var(--font-family-fira);
						line-height: 1.3em;

						img{
							margin-right: 7px;
							width: 28px;
							height: auto;
						}
					}
				}

				.fecha-hora{
					color: var(--color-blue-dark);
					font-size: 20px;
					padding-left: 10px;
					border-left: 1px solid var(--color-blue-dark);
					margin-left: 20px;
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
				}
			}

			.espectaculo-competencia{
				width: 100%;
				@include flex(row, center, center);

				img{
					max-height: 28px;
					width: auto;
					margin-right: 15px;
				}

				.espectaculo-competencia-info{
					@include flex(column, center, flex-start);

					.nombre-competencia{
						color: var(--color-blue-dark);
						font-size: 13px;
						font-weight: var(--font-weight-bold);
						font-family: var(--font-family-fira);
						line-height: 1.3em;
					}

					.instancia-competencia{
						color: var(--color-blue-dark);
						font-size: 12px;
						font-weight: var(--font-weight-regular);
						font-family: var(--font-family-fira);
						line-height: 1.3em;
					}
				}
			}

			.espectaculo-bottom{
				width: 100%;
				background-color: var(--color-blue-dark);
				height: 10px;
				border-radius: 0px;
				position: absolute;
				bottom: 0;
				left: 0;
				padding: 0 20px;
				margin: 0;
			}

			.espectaculo-bottom-right{
				width: 50%;
				background-color: var(--color-red);
				height: 10px;
				border-radius: 0px;
				position: absolute;
				bottom: 0;
				right: 0;
				padding: 0 20px;
				margin: 0;
			}

			&.espectaculo-alternativo{
				// background-color: #11244c;
				display: flex;
				flex-direction: column;
				justify-content: space-evenly;

				.titulo-alternativo{
					font-family: var(--font-family-poppins);
					color: var(--color-blue-dark);
					line-height: 1.2em;
					font-size: 26px;
					font-weight: var(--font-weight-bold);
					text-align: center;
					width: 100%;
					text-transform: uppercase;
					margin-bottom: 15px;
				}

				.espectaculo-info{
					margin-bottom: 0px;
				}

				/* Agregado temporalmente para abonos del basket */
				// .espectaculo-info{
				// 	display: none;
				// }

				&.espectaculo-abono{
					background-color: var(--color-red);
					border-radius: 12px;

					.titulo-alternativo{
						color: var(--color-white);
						font-size: 28px;
						line-height: 1.4em;
					}

					.espectaculo-bottom{
						border-radius: 0px 0px 12px 12px;
						background-color: var(--color-blue);

						.espectaculo-bottom-right{
							background-color: var(--color-blue);
							border-radius: 0px 0px 12px 0px;
						}
					}
				}
			}

			&.espectaculo-paseo{
				padding-bottom: 25px;

				@include flex(column, space-between, center);

				.paseo-top{
					width: 100%;
					@include flex(column, flex-start, center);

					img{
						margin-bottom: 10px;
						width: 80%;
						height: auto;
					}
				}

				.paseo-button{
					width: 75%;
					@include flex(row, center, center);
					text-transform: uppercase;
					font-family: var(--font-family-poppins);
					font-weight: var(--font-weight-bold);
					position: relative;
					cursor: pointer;
					background-color: var(--color-white);
					color: var(--color-blue);
					-webkit-transition: background-color .2s ease;
					transition: background-color .2s ease;
					-webkit-letter-spacing: 1px;
					-moz-letter-spacing: 1px;
					-ms-letter-spacing: 1px;
					letter-spacing: 1px;
					padding: 12px 14px;
					font-size: 13px;
					line-height: 16px;
					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					outline-color: transparent;
					outline: none;
					box-shadow: none;
					// border: 1px solid var(--color-blue);
					margin: 0;

					-webkit-touch-callout: none;
					-webkit-user-select: none;
					-khtml-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					user-select: none;

					svg{
						width: 17px;
						height: auto;
						margin-left: 10px;
						margin-top: -2px;
						color: var(--color-blue);
					}
				}

				.paseo-footer{
					width: 100%;
					@include flex(column, flex-end, center);

					img{
						margin-top: 10px;
						width: 80%;
						height: auto;
					}
				}
			}
		}
	}

	.slider-sponsors{
		margin: 30px 0;
	}

	/* Responsive */
	@media screen and (max-width: 1300px){
		.espectaculos-home{
			padding-left: 24px;
			padding-right: 24px;
		}
	}

	@media screen and (max-width: 1160px){
		.espectaculos-home .espectaculos-row{
			grid-template-columns: repeat(2, 1fr);
		}
	}

	@media screen and (max-width: 900px){
		.espectaculos-home .espectaculos-top h2{
			font-size: 36px;
		}

		.espectaculos-home .espectaculos-top a{
			font-size: 14px;

			&:after{
				height: 3px;
			}
		}
	}

	@media screen and (max-width: 770px){
		.espectaculos-home .espectaculo{
			// width: 100%;
			// margin-bottom: 30px;
			max-width: 450px;
			margin: 0 auto;
		}

		.espectaculos-home .espectaculos-row{
			// @include flex(column, flex-start, center);
			grid-template-columns: repeat(1, 1fr);
		}

		.espectaculos-home .espectaculos-top h2{
			margin-bottom: 5px;
		}

		.espectaculos-home {
			.espectaculos-top{
				@include flex(column, flex-start, flex-start);
				a{
					font-size: 12px;
					margin-bottom: 10px;

					&:after{
						right: auto;
						left: 0px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		.espectaculos-home{
			.espectaculo {
				min-height: 200px;
				
				.espectaculo-top{
					span.vs{
						font-size: 15px;
					}

					.equipo{
						img{
							height: 46px;
						}
					}
				}

				.espectaculo-info{
					.fecha-lugar{
						.fecha{
							font-size: 14px;
						}

						.lugar{
							font-size: 13px;

							img{
								width: 23px;
							}
						}
					}

					.fecha-hora{
						font-size: 22px;
					}
				}

				.espectaculo-competencia{
					img{
						max-height: 24px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 400px){
		.espectaculos-home{
			.espectaculo{
				.espectaculo-tipo{
					// width: 70%;
					text-align: center;
				}

				.espectaculo-top{
					.equipo{
						img{
							height: 38px;
						}

						span{
							font-size: 13px;
						}
					}
				}

				.espectaculo-info{
					.fecha-hora{
						font-size: 16px;
					}

					.fecha-lugar{
						.fecha{
							font-size: 12px;
						}

						.lugar{
							font-size: 12px;

							img{
								margin-right: 4px;
								width: 20px;
							}
						}
					}
				}

				.espectaculo-competencia{
					.espectaculo-competencia-info{
						.nombre-competencia{
							font-size: 12px;
						}
					}
				}
			}
		}
	}
</style>